import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { cn } from '../../lib/utils';
const FAQS = [{
  q: 'When should I have a contract reviewed?',
  a: 'Before signing or bidding wherever possible. A review can identify conditions, disclosures and transaction risks that may affect your decision or require further advice.'
}, {
  q: 'What is a Section 32 vendor statement?',
  a: 'It is a disclosure document a Victorian seller provides to a buyer before the buyer signs the contract. It contains prescribed information about the property and should be considered together with the contract.'
}, {
  q: 'Can you help with an auction purchase?',
  a: 'The contract should ideally be reviewed before auction day because auction contracts are generally unconditional once the property is purchased. Send the contract and auction date with your enquiry.'
}, {
  q: 'Can you assist with an SMSF or trust purchase?',
  a: 'The existing practice information lists SMSF, family trust and unit trust property transactions. These matters commonly require coordination between the legal team, accountant, adviser and lender.'
}, {
  q: 'How quickly can a contract be reviewed?',
  a: 'Timing depends on the document, transaction and current workload. Include your signing or auction deadline when submitting the contract so the team can assess urgency.'
}, {
  q: 'Do I need a property lawyer or a conveyancer?',
  a: 'Both lawyers and licensed conveyancers can manage conveyancing work within their authorised scope. A property lawyer can also advise on broader legal issues when a transaction becomes more complex.'
}, {
  q: 'How much does conveyancing cost in Victoria?',
  a: 'Fees depend on the property and the transaction, so we provide a confirmed fixed scope and fee in writing before any work begins. There is no cost to send a contract or request a quote, and no obligation to proceed.'
}, {
  q: 'What is the cooling-off period when buying property in Victoria?',
  a: 'For many private-sale residential purchases in Victoria there is a cooling-off period of three clear business days after signing the contract, with some exceptions, including auction purchases. Check your contract and obtain advice, because conditions and exceptions can apply to your situation.'
}, {
  q: 'What checks happen before settlement?',
  a: 'Before settlement the team reviews the title and any encumbrances, confirms adjustments for rates and outgoings, prepares and verifies settlement figures, and coordinates the date and requirements with the other party. You are kept informed as the matter reaches completion.'
}, {
  q: 'Do I need a lawyer for an off-the-plan purchase?',
  a: 'Off-the-plan contracts can be longer and more complex, with disclosure, sunset dates and variation clauses that benefit from legal review before you sign. Send the contract and any deadline with your enquiry.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-28 px-5 md:px-6 bg-cream" data-id="element-239">
      <div className="max-w-3xl mx-auto" data-id="element-240">
        <div className="text-center mb-12" data-id="element-241">
          <p className="text-accent font-script text-2xl mb-1" data-id="element-242">good to know</p>
          <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-243">
            Common property questions.
          </h2>
        </div>

        <div className="space-y-3" data-id="element-244">
          {FAQS.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={cn('rounded-2xl border bg-surface overflow-hidden transition-colors', isOpen ? 'border-accent/40' : 'border-border')} data-id="element-245">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-inset" aria-expanded={isOpen} data-id="element-246">
                  <span className="font-serif text-lg md:text-xl text-ink" data-id="element-247">
                    {faq.q}
                  </span>
                  <span className={cn('inline-flex w-8 h-8 items-center justify-center rounded-full shrink-0 transition-all duration-300', isOpen ? 'bg-accent text-white rotate-45' : 'bg-accent-soft text-accent')} data-id="element-248">
                    <Plus className="w-4 h-4" strokeWidth={2.5} data-id="element-249" />
                  </span>
                </button>
                <div className={cn('grid transition-all duration-300 ease-soft', isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0')} data-id="element-250">
                  <div className="overflow-hidden" data-id="element-251">
                    <p className="px-5 md:px-6 pb-6 text-muted-ink leading-relaxed" data-id="element-252">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}